import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';

import RemoveStudentExam from './RemoveStudentExam.gql';

export default class RemoveStudentExamModal extends Component {
  state = {
    modalOpen: false,
  };

  closeModal = () => {
    this.setState({ modalOpen: false });
  };

  openModal = () => {
    this.setState({ modalOpen: true });
  };

  renderTrigger = () => {
    return React.cloneElement(this.props.trigger, { onClick: this.openModal });
  };

  render() {
    const { roundCode, examCard, roundTitle } = this.props;
    return (
      <Modal
        className={'scrolling'}
        trigger={this.renderTrigger()}
        dimmer="inverted"
        open={this.state.modalOpen}
      >
        <RemoveStudentExam
          roundCode={roundCode}
          examCard={examCard}
          onClose={this.closeModal}
          roundTitle={roundTitle}
        />
      </Modal>
    );
  }
}
